export const getNumbersFromString = (str: string): string => {
  const numbersArray = str.match(/\b\d+\b/g);
  if (numbersArray?.length) {
    return numbersArray.join('');
  }

  return '';
};
